var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDuration4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#af9b5b;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "duree4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.63,37s-12-9.16-18-27V37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.9,37l2.17-3.8s-3.91,1.1-11.46-11.39V37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.61,21.81V37H36.9s-8.19-9-9.29-15.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.44,32.86,27.76,10.46c.25.72.51,1.44.79,2.13L46.44,34.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.13 34.89 48.13 36.08 48.62 36.67 49.22 36.2 48.13 34.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.59,37s12-9.16,18-27V37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.32,37l-2.17-3.8s3.91,1.1,11.46-11.39V37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.61,21.81V37H18.32s8.19-9,9.29-15.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.09 34.89 6 36.2 6.6 36.67 7.09 36.08 7.09 34.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.78,32.86v1.19l17.9-21.46c.27-.69.53-1.41.78-2.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.44,
    y: 31.95,
    width: 1.7,
    height: 5.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.09,
    y: 31.95,
    width: 1.7,
    height: 5.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuration4);
export default __webpack_public_path__ + "static/media/icon_duration_4.68ebc2e2530bb19f1c4a5d03c067b4c4.svg";
export { ForwardRef as ReactComponent };